import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { AuthenticationService, profileType } from 'app/services/auth.service';

/**
 * it would show user's brief information in a card container.
 */
@Component({
    selector: 'app-user-profile-card',
    templateUrl: './user-profile-card.component.html',
    styleUrls: ['./user-profile-card.component.scss']
})
export class UserProfileCardComponent implements OnInit {
  auth = inject(AuthenticationService);

  // user's brief info. It's assumed, profile has value once the component is initialized.
  @Input() profile!: Readonly<profileType>;
  @Input() canUpdateContact? = false;
  @Input() relatedProfiles?: Readonly<profileType[]>;
  @Output() update = new EventEmitter<void>();
  addressLines: string[] = [];
  clientsList = '';
  isPgf = false;

  ngOnInit() {
    this.isPgf = this.profile.AdvisorType === 'Donor' || this.profile.AdvisorType === 'Successor';
    this.addressLines = [
      this.profile.Address1,
      this.profile.Address2,
      this.profile.Address3,
      [
        this.profile.City,
        this.profile.Province,
        this.profile.Country,
        this.profile.Postal
      ].filter(str => str != null && str !== '').join(', ')
    ].filter(str => str != null && str !== '');
    if (this.profile.AdvisorType && this.relatedProfiles) {
      const clients = this.profile?.ClientIds?.split(',')
        .map(c=>this.relatedProfiles?.find(r=>r.NameId===parseInt(c))?.Name)
        .filter(c=>!!c)
        .join(', ');
      if (clients)
        this.clientsList = 'of ' + clients;
    }
  }

  showTheForm(): void {
    this.update.emit();
  }
}
